export const GET_TEMPLATES_LIST = "GET_TEMPLATES_LIST";
export const GET_TEMPLATES_LIST_SUCCESS = "GET_TEMPLATES_LIST_SUCCESS";
export const GET_TEMPLATES_LIST_FAIL = "GET_TEMPLATES_LIST_FAIL";

export const ADD_TEMPLATE = "ADD_TEMPLATE";
export const ADD_TEMPLATE_SUCCESS = "ADD_TEMPLATE_SUCCESS";
export const ADD_TEMPLATE_FAIL = "ADD_TEMPLATE_FAIL";

export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_FAIL = "DELETE_TEMPLATE_FAIL";
